export default "__VITE_ASSET__BWdp79LU__"